import { Injectable } from '@angular/core';
import { AgentStatIndicator } from '../models/agent-stat.model';
import { BcRestApi } from 'common/api/rest-api';
import { AgentStatsHelper } from '../agent-stat-helper';

@Injectable()
export class AgentStatsService {

  constructor(private _bcRestApi: BcRestApi) {
  }

  public isOverPerform(value): boolean {
    return value > 100;
  }

  public getStatSettings(): Promise<AgentStatIndicator[]> {
    return this._bcRestApi.getAgentStatsSettings().then(response => {
      return response;
    });
  }

  public getCompareToDuration(indicatorCompareToDuration): string {
    return AgentStatsHelper.convertIndicatorCompareToDuration(indicatorCompareToDuration);
  }

  public getPerformancePercentage(target: number, current: number): number {
    return AgentStatsHelper.calculatePerformancePercentage(target, current);
  }

  public getTextsBasedOnIndicatorType(indicatorType) {
    return AgentStatsHelper.getTextsBasedOnIndicatorType(indicatorType);
  }

  public getDuration(indicatorDuration): string {
    return AgentStatsHelper.convertIndicatorDuration(indicatorDuration);
  }

  public isComparison(indicator): boolean {
    return AgentStatsHelper.isComparison(indicator);
  }
}
